export default __webpack_public_path__ + "static/media/fi.6a71a94d.svg";